import type { ReactElement } from 'react'

import MandatoryStar from '../MandatoryStar'

import './index.scss'

const RequiredInformation = (): ReactElement => {
  return (
    <div className="required-information">
      <MandatoryStar /> Required information
    </div>
  )
}

export default RequiredInformation
